'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _form = require('../form');

var _makerActions = require('../../actions/makerActions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ReportOptions = function (_React$Component) {
	_inherits(ReportOptions, _React$Component);

	function ReportOptions(props) {
		_classCallCheck(this, ReportOptions);

		return _possibleConstructorReturn(this, (ReportOptions.__proto__ || Object.getPrototypeOf(ReportOptions)).call(this, props));
	}

	_createClass(ReportOptions, [{
		key: 'render',
		value: function render() {
			var _props$report = this.props.report,
			    title = _props$report.title,
			    description = _props$report.description,
			    isPrivate = _props$report.isPrivate;


			return _react2.default.createElement(
				'div',
				{ className: 'report-options' },
				_react2.default.createElement(_form.Input, {
					onChange: this.handleTextChange.bind(this, 'title'),
					placeholder: 'Title',
					defaultValue: title,
					wrapperClass: 'option-input',
					label: 'Title'
				}),
				_react2.default.createElement(_form.Input, {
					onChange: this.handleTextChange.bind(this, 'description'),
					placeholder: 'Description',
					defaultValue: description,
					wrapperClass: 'option-input',
					label: 'Description'
				}),
				_react2.default.createElement(_form.Checkbox, {
					onChange: this.handleTextChange.bind(this, 'isPrivate'),
					defaultValue: description,
					checked: isPrivate,
					wrapperClass: 'option-input',
					label: 'Private'
				})
			);
		}
	}, {
		key: 'handleTextChange',
		value: function handleTextChange(field, e) {
			var _props = this.props,
			    report = _props.report,
			    dispatch = _props.dispatch;

			report[field] = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
			dispatch((0, _makerActions.updateReport)(report, report));
		}
	}, {
		key: 'handleSelectChange',
		value: function handleSelectChange(field, value) {
			var _props2 = this.props,
			    report = _props2.report,
			    dispatch = _props2.dispatch;

			report[field] = value.map(function (e) {
				return e.value;
			});
			dispatch((0, _makerActions.updateReport)(report, report));
		}
	}]);

	return ReportOptions;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
	return {
		report: state
	};
};

ReportOptions = (0, _reactRedux.connect)(mapStateToProps)(ReportOptions);

exports.default = ReportOptions;


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/components/maker/ReportOptions.js
// module id = 581
// module chunks = 0